module.exports = __webpack_public_path__ + "assets/624c3c6768f1aba43451c9b62148b2b6.png";